import { render, staticRenderFns } from "./FloatingCamV2.vue?vue&type=template&id=76b23c01&scoped=true"
import script from "./FloatingCamV2.vue?vue&type=script&lang=js"
export * from "./FloatingCamV2.vue?vue&type=script&lang=js"
import style0 from "./FloatingCamV2.vue?vue&type=style&index=0&id=76b23c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b23c01",
  null
  
)

export default component.exports